import SitterCard from "./SitterCard";
import useTranslation from "next-translate/useTranslation";

import { Box, Flex } from "rebass/styled-components";
import { useRef } from "react";
import { ServiceType } from "../../interfaces";
import { Caregiver } from "../../generated/graphql";

interface Props {
  searchResults: any;
  onVisible: (caregiver) => any;
  fetchMore: any;
  loading: boolean;
  serviceType: ServiceType;
}

interface SearchResultWrapperProps {
  caregiver: Caregiver;
  queryParams: any;
  listRef: any;
  [x: string]: any;
  serviceType: ServiceType;
}

function SearchResultWrapper({
  caregiver,
  queryParams,
  serviceType
}: SearchResultWrapperProps) {
  const { t } = useTranslation("common");

  const {
    name,
    avatar,
    caregiverHeadline,
    caregiverReviewsCount,
    caregiverReviewsScore,
    caregiverCompletedBookingsCount,
    slug,
    publicAddress,
    availablePromotions
  } = caregiver;

  return (
    <Box
      sx={{
        backgroundColor: "samoyedWhite",
        minWidth: "85vw",
        width: "85vw",
        scrollSnapAlign: "start",
        mx: 1,
        overflow: "hidden",
        maxHeight: "180px",
        flex: "0 0 auto"
      }}
      px={1}
      className="searchItem"
    >
      <SitterCard
        name={name!}
        headline={caregiverHeadline!}
        avatar={avatar?.circle!}
        price={caregiver.price!}
        repeatCustomersCount={caregiver.repeatCustomersCount!}
        priceCurrency={caregiver.currency!}
        pricePer={serviceType && t(serviceType.pricePer!)}
        bookingEstimation={caregiver.bookingEstimation!}
        reviewsCount={caregiverReviewsCount!}
        reviewsScore={caregiverReviewsScore!}
        completedBookingsCount={caregiverCompletedBookingsCount!}
        slug={slug!}
        queryParams={queryParams}
        address={publicAddress!}
        hideHover
        availablePromotions={availablePromotions}
        city={caregiver.city}
        caregiverCalendarUpdatedAt={caregiver.caregiverCalendarUpdatedAt}
        slim
        isSuperCaregiver={caregiver?.isSuperCaregiver}
      />
    </Box>
  );
}

interface SearchCarouselProps {
  [x: string]: any;
  serviceType: ServiceType;
}
function SearchCarousel({
  searchResults,
  onVisible,
  queryParams,
  serviceType
}: SearchCarouselProps) {
  const ref = useRef(null);

  return (
    <Flex
      className="searchCarousel"
      sx={{
        zIndex: 1,
        overflowY: "hidden",
        overflowX: "auto",
        position: "absolute",
        width: "100%",
        bottom: 2,
        scrollPaddingLeft: "8px",
        scrollSnapType: "x mandatory",
        "::-webkit-scrollbar": {
          display: "none"
        },
        flexWrap: "nowrap"
      }}
      ref={ref}
    >
      {searchResults.map(caregiver => {
        return (
          <SearchResultWrapper
            key={caregiver.id}
            caregiver={caregiver}
            queryParams={queryParams}
            onVisible={onVisible}
            listRef={ref}
            serviceType={serviceType}
          />
        );
      })}
    </Flex>
  );
}

export default function SearchResultCarousel({
  searchResults,
  onVisible,
  serviceType
}: Props) {
  return (
    <SearchCarousel
      searchResults={searchResults}
      onVisible={onVisible}
      serviceType={serviceType}
    />
  );
}
